import React from 'react';
import { MethodBadge } from './Badges';
import type { HttpMethod } from './types';

/** กรอบการ์ดของ 1 endpoint (หัวการ์ด = method + path) */
const EndpointCard: React.FC<{ method: HttpMethod; path: string; children: React.ReactNode }> = ({ method, path, children }) => (
  <div className="api-docs-glow-card rounded-xl border border-gray-200/70 dark:border-slate-700 mb-6 bg-white dark:bg-slate-800 shadow-sm hover:shadow-md transition-shadow duration-300">
    <div className="flex items-center gap-3 px-5 py-3.5 border-b border-gray-100 dark:border-slate-700 bg-gray-50/50 dark:bg-slate-700/40 rounded-t-xl">
      <MethodBadge method={method} />
      <code className="text-gray-700 dark:text-slate-200 font-mono text-sm font-medium">{path}</code>
    </div>
    <div className="p-5">{children}</div>
  </div>
);

export default EndpointCard;
